export default "__VITE_ASSET__VbfR2cgm__"